import "./aboutMe.css";
export function AboutMe() {
  return (
    <div id="aboutme" className="container ">
      <div className="row aboutI">
        <div className="col-xl-6 col-xxl-6">
          <img className="img-fluid myfoto" src={require("./materials/i.jpg")} alt={3} />
        </div>
        <div className="col-xl-6 col-xxl-6 mt-5 ">
          <h1 className="boxe text-start p-5">
            <h1 className="textColorSelect2">Мила Дудина</h1>
            <h4 className="textColorSelect3"> проффесиональный фотограф</h4>
            <br />
            <h5>
              Я — Мила, женский фотограф из Москвы. Снимаю девушек в уличном
              стиле — легко, эстетично и с душой.
            </h5>
            <br />
            <h5>
              Работаю с камерой с 2016 года, и за это время поняла главное:
              фотография — это не просто кадр, а способ увидеть себя по-новому,
              полюбить и принять.
            </h5>
          </h1>
          {/* <div className="boxLine d-none d-xl-block"></div> */}
       
        </div>
      </div>

      <div className="pt-5">
        <h1>
          <span className="textColorSelect">Клиенты</span> выбирают меня
        </h1>
      </div>

      <div className="row">
        <div className="col-xxl-4 p-5">
          <div>
            <h5>
              <i class="fa-regular fa-map fa-lg"></i>Съемка на выезде, в студии
              или у вас дома
            </h5>
          </div>
          <p> Помогаю выбрать лучшую локацию, с учетом ваших пожеланий.</p>
        </div>
        <div className="col-xxl-4 p-5">
          <div>
            <h5>
              <i class="fa-solid fa-handshake-angle fa-lg"></i>Помощь на каждом
              этапе фотосессии
            </h5>
          </div>
          <p>
            Помогаю в подборе образа для съемки, помогаю в позировании, создаю
            дружескую атмосферу.
          </p>
        </div>
        <div className="col-xxl-4 p-5">
          <div>
            <h5>
              <i class="fa-solid fa-eye fa-lg"></i>Обработка фотографий
            </h5>
          </div>
          <p>
            У каждого клиента индивидуальная обработка. Никогда не применяю одни
            и те же настройки к кадрам других клиентов
          </p>
        </div>
      </div>

      <div className="row">
        <div className="col-xxl-6 pb-5">
          <div>
            <h5>
              <i class="fa-solid fa-gauge-high fa-lg"></i>Скорость работы
            </h5>
          </div>
          <p>3-10 дней, в зависимости от сложности проекта.</p>
        </div>
        <div className="col-xxl-6 pb-5">
          <div>
            <h5>
              <i class="fa-solid fa-coins fa-lg"></i>Адекватная стоимость
            </h5>
          </div>
          <p>
            Вы можете выбрать из трех пакетов услуг тот, который подходит именно
            вам.
          </p>
        </div>
      </div>
    </div>
  );
}
